import React from 'react';
import { Minus, Plus, Trash2 } from 'lucide-react';
import { CartItem as CartItemType } from '../../lib/types';
import { formatCurrency, cn } from '../../lib/utils';
interface CartItemProps {
  item: CartItemType;
  onUpdateQuantity: (id: string, quantity: number) => void;
  onRemove: (id: string) => void;
  theme?: 'default' | 'capricho';
}
export function CartItem({
  item,
  onUpdateQuantity,
  onRemove,
  theme = 'default'
}: CartItemProps) {
  const optionsTotal = item.selected_options.reduce((sum, opt) => sum + opt.price_delta, 0);
  const unitPrice = item.unit_price_snapshot + optionsTotal;
  const lineTotal = unitPrice * item.quantity;
  const isCapricho = theme === 'capricho';
  return <div className={cn('flex gap-3 py-4 border-b last:border-0', isCapricho ? 'border-[#E8DDD0]' : 'border-white/5')} data-id="element-669">
      {/* Image if available */}
      {item.image_url && <div className={cn('w-14 h-14 rounded-xl overflow-hidden shrink-0 border', isCapricho ? 'bg-[#F5E9DA] border-[#E8DDD0]' : 'bg-[#1a1a1a] border-white/5')} data-id="element-670">
          <img src={item.image_url} alt={item.item_name_snapshot} className="w-full h-full object-cover" data-id="element-671" />
        </div>}

      <div className="flex-1 flex flex-col min-w-0" data-id="element-672">
        <div className="flex justify-between items-start mb-0.5" data-id="element-673">
          <h4 className={cn('font-semibold text-sm leading-tight pr-2', isCapricho ? 'text-[#3D2B1F]' : 'text-[#F8F5F0]')} data-id="element-674">
            {item.item_name_snapshot}
          </h4>
          <button onClick={() => onRemove(item.id)} className={cn('transition-colors p-1 -mr-1 shrink-0', isCapricho ? 'text-[#8B7355] hover:text-[#CE1126]' : 'text-[#F8F5F0]/30 hover:text-[#E63946]')} aria-label="Eliminar producto" data-id="element-675">
            <Trash2 className="w-4 h-4" data-id="element-676" />
          </button>
        </div>

        {/* Options */}
        {item.selected_options.length > 0 && <ul className={cn('text-xs mb-1.5 space-y-0.5', isCapricho ? 'text-[#8B7355]' : 'text-[#F8F5F0]/50')} data-id="element-677">
            {item.selected_options.map((opt, idx) => <li key={idx} className="flex justify-between" data-id="element-678">
                <span className="truncate pr-2" data-id="element-679">• {opt.option_name}</span>
                {opt.price_delta > 0 && <span className="shrink-0" data-id="element-680">
                    +{formatCurrency(opt.price_delta)}
                  </span>}
              </li>)}
          </ul>}

        {/* Notes */}
        {item.notes && <p className={cn('text-xs px-2 py-1 rounded-md mb-2 italic line-clamp-2', isCapricho ? 'text-[#8B5E3C] bg-[#F5E9DA]' : 'text-[#F4D35E] bg-[#F4D35E]/10')} data-id="element-681">
            "{item.notes}"
          </p>}

        <div className="mt-auto flex items-center justify-between pt-1" data-id="element-682">
          {/* Quantity Controls */}
          <div className={cn('flex items-center rounded-lg p-0.5 border', isCapricho ? 'bg-[#FBF7F2] border-[#E8DDD0]' : 'bg-[#1a1a1a] border-white/10')} data-id="element-683">
            <button onClick={() => onUpdateQuantity(item.id, item.quantity - 1)} className={cn('w-7 h-7 flex items-center justify-center rounded-md transition-all', isCapricho ? 'text-[#8B7355] hover:text-[#3D2B1F] hover:bg-white' : 'text-[#F8F5F0]/60 hover:text-[#F8F5F0] hover:bg-[#2a2a2a]')} data-id="element-684">
              <Minus className="w-3.5 h-3.5" data-id="element-685" />
            </button>
            <span className={cn('w-7 text-center font-semibold text-sm', isCapricho ? 'text-[#3D2B1F]' : 'text-[#F8F5F0]')} data-id="element-686">
              {item.quantity}
            </span>
            <button onClick={() => onUpdateQuantity(item.id, item.quantity + 1)} className={cn('w-7 h-7 flex items-center justify-center rounded-md transition-all', isCapricho ? 'text-[#8B7355] hover:text-[#3D2B1F] hover:bg-white' : 'text-[#F8F5F0]/60 hover:text-[#F8F5F0] hover:bg-[#2a2a2a]')} data-id="element-687">
              <Plus className="w-3.5 h-3.5" data-id="element-688" />
            </button>
          </div>

          <div className={cn('font-bold text-sm', isCapricho ? 'text-[#C8A96A]' : 'text-[#F4D35E]')} data-id="element-689">
            {formatCurrency(lineTotal)}
          </div>
        </div>
      </div>
    </div>;
}